<template>
    <div class="main-con">
        <table class="data-table">
            <thead style="z-index: 1">
                <tr>
                    <th class="width-pixel-50" @click="sortOptionChange('rentalcompanyId','number')" >업체ID</th>
                    <th class="bottom-header-text" @click="sortOptionChange('rentalcompanyName')" >업체명</th>
                    <th class="width-pixel-50" @click="sortOptionChange('accountId','number')" >거래처ID</th>
                    <th class="bottom-header-text" @click="sortOptionChange('accountName')" >거래처명</th>
                    <th class="width-pixel-50" @click="sortOptionChange('tnDeviceId')" >장치ID</th>
                    <th class="width-percent-10" @click="sortOptionChange('serialNo')">시리얼</th>
                    <th class="width-pixel-70" @click="sortOptionChange('firmwareVersion')" >버전</th>
                    <th class="width-pixel-50" @click="sortOptionChange('useYn')" >사용여부</th>
                    <th class="width-percent-7" @click="sortOptionChange('installLocation')">설치위치</th>
                    <th class="width-pixel-100" @click="sortOptionChange('uptStateDatetime')" >상태변경일시</th>
                    <th class="width-pixel-100" @click="sortOptionChange('ip')" >ip</th>
                    <th class="width-pixel-100" @click="sortOptionChange('remoteIp')" >원격ip</th>
                    <th class="width-pixel-100" @click="sortOptionChange('installDatetime')" >입고일시</th>
                    <th class="width-percent-7" @click="sortOptionChange('deviceType')">장치 유형</th>
                    <th class="width-pixel-50" @click="sortOptionChange('deleteYn')" >삭제여부</th>
                    <th class="width-percent-7" @click="sortOptionChange('register')">등록자</th>
                    <th class="width-percent-7" @click="sortOptionChange('installWorkerName')">입고자명</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(item, index) in tableBodyData" :key="index" @click="()=>clickNewTabDeviceDetail(item)">
                    <td class="table-text-center">{{item.rentalcompanyId}}</td>
                    <td  :title="item.rentalcompanyName" class="column-size-short">{{item.rentalcompanyName}}</td>
                    <td class="table-text-center">{{item.accountId}}</td>
                    <td :title="item.accountName" class="column-size-short">{{item.accountName}}</td>
                    <td class="table-text-center">{{item.tnDeviceId}}</td>
                    <td :title="item.serialNo" class="column-size-short">{{item.serialNo}}</td>
                    <td>{{item.firmwareVersion}}</td>
                    <td>
                        <y-n-button-flag
                            :what-type-name="'device'"
                            :id-key-name="'tnDeviceId'"
                            :flag-key-name="'useYn'"
                            :serial="item.tnDeviceId"
                            :button-flag="item.useYn"
                            @refresh-data-load="refreshDataLoad"
                        />
                    </td>
                    <td :title="item.installLocation" class="column-size-short">{{item.installLocation}}</td>
                    <td>{{dateFormatChange(item.uptStateDatetime)}}</td>
                    <td :title="item.ip" class="column-size-short">{{item.ip}}</td>
                    <td>{{item.remoteIp}}</td>
                    <td>{{dateFormatChange(item.installDatetime)}}</td>
                    <td>{{item.deviceType}}</td>
                    <td>
                        <y-n-button-flag
                        :what-type-name="'device'"
                        :id-key-name="'tnDeviceId'"
                        :flag-key-name="'deleteYn'"
                        :serial="item.tnDeviceId"
                        :button-flag="item.deleteYn"
                        @refresh-data-load="refreshDataLoad"
                        />
                    </td>
                    <td :title="item.register" class="column-size-short">{{item.register}}</td>
                    <td :title="item.installWorkerName" class="column-size-short">{{item.installWorkerName}}</td>
                </tr>
                <v-btn
                    :color="disableButton ? 'primary':'#cccccc'"
                    dark
                    large
                    @click="plusLoadButtonClick"
                    class="add-load-button"
                >
                    추가로드
                </v-btn>
            </tbody>
        </table>
    </div>
</template>

<script>
/**
 * 장치 목록 컴포넌트에서 테이블 부분입니다.
 *
 */
import {DateTime} from "luxon";
import YNButtonFlag from "@/views/monitoring/deviceList/YNButtonFlag";

export default {
    name: "NoLibraryBagicTable",
    components: {
        YNButtonFlag
    },
    data() {
        return {
        }
    },
    props :{
        tableBodyData:{
            type:Array,
            default:()=>[]
        },
        disableButton:{
            type:Boolean,
            default:false
        },
    },
    methods: {
        /**
         * 칼럼 클릭시 동작합니다.
         * 장시 상세 페이지로 이동하며 tnDeviceId를 전달해서
         * 상세 페이지의 테이블 데이터 요청을 합니다.
         */
        clickNewTabDeviceDetail({rentalcompanyId,tnDeviceId,accountId, deviceType}){
            if(!rentalcompanyId||!tnDeviceId){
                alert("다시 선택해주세요")
                return
            }
            this.$router.push({
                name: 'managertnbox.monitoring.device.list.detail.info',
                query:{rentalcompanyId,tnDeviceId,accountId, deviceType},
            });
        },
        /**
         * 추가로드 버튼을 클릭시 동작합니다.
         */
        plusLoadButtonClick() {
            if(!this.disableButton) return //데이터가 없을때 추가로드 비활성화 합니다.
            this.$emit('page-number-plus');
        },
        /**
         * flag 버튼 클릭시 동작합니다.
         * @param body
         * @param name
         */
        refreshDataLoad(){
            this.$emit("refresh-data-load")
        },
        /**
         * type이 date 인 cell은 Utc+9로 변경합니다
         * @param row
         * @returns {*}
         */
        dateFormatChange(date){
            if (!date) return undefined
            return DateTime.fromISO(DateTime.fromISO(date, {zone: 'utc'}).toISO()).toFormat("yyyy-MM-dd HH:mm")
        },
        /**
         * header에 있는 칼럼을 클릭시 동작합니다.
         * 정렬을 하기위해 해당 칼럼의 이름을 전달합니다.
         */
        sortOptionChange(columnName) {
            this.$emit("sort-options-data-change",columnName)
        },
    }
}
</script>

<style scoped>

>>> input[type=checkbox] {
    position: absolute;
}

.main-con{
    height: 100%;
    overflow-y: auto;
}
.main-con .data-table{
    table-layout: fixed;
    border-spacing: 0;
    width: 130%;
    overflow-x: auto;
}
.main-con .data-table thead{
    position: sticky;
    top: 0;
    background: #ddd;
}
.top-header-wrapper{
    background: #E5F4FF;
}
.top-header-text{
    border: 1px solid #6f6f6f;
}
.main-con .data-table thead tr th {
    font-size: 11px;
    padding-right: 8px;
}

.main-con .data-table tbody td{
    text-align: left;
    border: 1px solid #ccc;
    font-size: 11px;
    padding: 0.15rem;
}

.main-con .data-table tbody tr:nth-child(even){
    background: #f5f5f5;
}
.main-con .data-table tbody tr:hover{
    background: #ddd;
}

.button-flex-left{
    display: flex;
    justify-content: space-between;
}
.column-size-short{
    text-overflow:ellipsis;
    overflow:hidden;
    white-space:nowrap;
}
.width-pixel-50{
    width: 50px !important;
}
.width-pixel-70{
    width: 70px !important;
}
.width-pixel-100{
    width: 100px !important;
}
.width-percent-7{
    width: 7% !important;
}
.width-percent-10{
    width: 10% !important;
}
.table-text-center{
    text-align: center !important;
}
</style>
